import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  form: {
    width: '100%',
  },
}));

export default useStyles;
